(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				console.log('init', this);
				var $this = $(this);
				var data = $this.data('comboSearch');
				
				if (!data) {
					var $wrapper = $("<div class='combosearch'>");
					var $ul = $("<ul>");
					$ul.attr("tabindex", "-1");
					www = $wrapper;
					var $input = $("<input type='text'>").on("click focus keyup", function(event){
						if (event.keyCode == 13 && $ul.find("li:visible:not(.not-found)").length === 1) {
							$ul.find("li:visible:not(.not-found)").click();
						}
						if (event.keyCode == 13 || event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 27) {
							event.preventDefault();
							return;
						}
						console.log("search!", event);
						$this.comboSearch('search');
					});
					
					$input.on("blur", function() {
						console.log("blurtrig");
						setTimeout(function(){
							$this.comboSearch('close');
							console.log("blur");
						}, 300);
					});
					
					$input.on("keydown", function(event) {
						if (event.keyCode == 27) {
							$this.comboSearch('close');
						}
						if (event.keyCode == 38 || event.keyCode == 40) {
							//38 up 40 down
							var $current = $ul.find("li.selected");
							var $toSelect;
							if ($current.length === 0) {
								if (event.keyCode == 38) {
									$toSelect = $ul.find("li:visible:not(.not-found)").last();
								} else {
									$toSelect = $ul.find("li:visible:not(.not-found)").first();
								}
							} else {
								if (event.keyCode == 38) {
									$toSelect = $current.prevAll(':visible:not(.not-found)').first();
									if ($toSelect.length === 0) {
										$toSelect = $ul.find("li:visible:not(.not-found)").last();
									}
								} else {
									$toSelect = $current.nextAll(':visible:not(.not-found)').first();
									if ($toSelect.length === 0) {
										$toSelect = $ul.find("li:visible:not(.not-found)").first();
									}
								}
							}
							
							if ($toSelect.length === 0) {
								return;
							}
							
							$toSelect.addClass("selected");
							$current.removeClass("selected");
							
							$this.val($toSelect.attr("data-value"));
							$input.val($toSelect.html());
							$input.attr("data-selected-text", $toSelect.html());
							
							
							if ($ul.find("li.selected").length === 0) {
								return;
							}
							
							var posMin = $ul.find("li.selected").position().top + $ul.scrollTop();
							var posMax = $ul.find("li.selected").position().top + $ul.scrollTop() + $ul.find("li.selected").outerHeight();
							if ($ul.scrollTop() > posMin) {
								$ul.scrollTop(posMin);
							}
							if ($ul.scrollTop() < posMax - $ul.innerHeight()) {
								$ul.scrollTop(posMax - $ul.innerHeight());
							}
						}
						
						if (event.keyCode == 13) {
							//enter
							$ul.find("li.selected").click();
							event.preventDefault();
						}
						
					});
					
					if ($this.attr("required")) {
						$input.attr("required", true);
					}
					
					var selected_val = $this.val();
					$this.find("option").each(function(n, el){
						if (!$(el).attr("data-combosearch-skip") && $(el).val() !== '') {
							var val = $(el).val().trim();
							var $li = $("<li>").attr("data-value", val).html($(el).html().trim());
							if($(el).attr("data-search_text")){
								var searchText = $(el).attr("data-search_text").trim();
								$li.attr("data-search_text", searchText);
							}
							$li.on("click", function(event){
								console.log("click", event);
								eee=event;
								$this.val($(event.target).attr("data-value"));
								$input.val($(event.target).html());
								$input.attr("data-selected-text", ($(event.target).html()));
								$this.comboSearch('close');
								
							});
							$li.appendTo($ul);
							if(selected_val == val) {
								$input.val($(el).html());
							}
						}
					});
					
					$("<li class='not-found'>Ничего не найдено...</li>").appendTo($ul);
					
					$input.appendTo($wrapper);
					$ul.appendTo($wrapper);
					
					
					$this.hide();
					$wrapper.insertAfter($this);
					
					$ul.css("border-color", $input.css("border-color"));
					var border_radius = $input.css("border-radius");
					
					if (border_radius) {
						$ul.css("border-bottom-left-radius", border_radius);
						$ul.css("border-bottom-right-radius", border_radius);
					}
					
					$this.data('comboSearch', {
						target: $this,
						wrapper: $wrapper,
						input: $input,
						border_radius: border_radius,
						ul: $ul
					});
					doo = $this.data('comboSearch');
				}
			});
		},
		
		search: function(){
			console.log("search!");
			var $this = $(this);
			var data = $this.data('comboSearch');
			if (!data) {
				$.error('Поиск на неинициализированном comboSearch!');
				return;
			}
			
			data.ul.find("li").hide();
			data.ul.find("li.selected").removeClass('selected');
			
			var term = data.input.val().toLowerCase().replaceAll('"', '').replaceAll("'", '').trim();
			var found = false;
			data.ul.find("li").each(function(n, el){
				var text = $(el).html().toLowerCase().replaceAll('"', '').replaceAll("'", '').trim();
				var searchText = $(el).attr("data-search_text")?.toLowerCase().replaceAll('"', '').replaceAll("'", '').trim() || "";
				if (text.includes(term) || searchText.includes(term)) {
					$(el).show();
					found = true;
				}
			});
			
			if (!found) {
				data.ul.find("li.not-found").show();
			} else if(term.length === 0){
				data.ul.find("li.not-found").hide();
			}
			
			if (data.border_radius) {
				data.input.css("border-bottom-left-radius", "0");
				data.input.css("border-bottom-right-radius", "0");
			}
			
			
			data.ul.show();
			
		}, 
		
		close: function(){
			console.log("close");
			var $this = $(this);
			var data = $this.data('comboSearch');
			if (!data) {
				$.error('Поиск на неинициализированном comboSearch!');
				return;
			}
			
			if (data.input.prop('disabled')) {
				return;
			}
			
			if (data.input.val() === "") {
				data.target.val('');
				data.input.attr("data-selected-text", '');
			} else {
				data.input.val(data.input.attr("data-selected-text"));
			}
			
			data.ul.hide();
			if (data.border_radius) {
				data.input.css("border-bottom-left-radius", data.border_radius);
				data.input.css("border-bottom-right-radius", data.border_radius);
			}
		}
	};
	$.fn.comboSearch = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.comboSearch');
		}
	};
})(jQuery);
